<template>
  <v-navigation-drawer
    v-model="drawer"
    enable-resize-watcher
    app
    right
    width="400"
    color="#FFF9EA"
  >
    <v-card flat v-if="coreCardTypeId == null" color="transparent">
      <v-card-text>
        <v-row dense>
          <v-col cols="auto">
            <v-btn icon @click="cancel" color="secondary">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="subtitle-2 my-auto">
            Last updated {{ lastUpdatedDays }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-title>
        CoreInsights <span class="primary--text caption ml-1">Beta</span>
      </v-card-title>
      <v-card-subtitle>
        Select a category below to view detailed insights
      </v-card-subtitle>
      <v-card-text>
        <loading-spinner v-if="loading"></loading-spinner>
        <v-row v-else>
          <v-col cols="12" v-for="(coreCard, i) in coreCards" :key="i">
            <insight-core-card
              :coreCard="coreCard"
              v-on:click="setCoreCard"
            ></insight-core-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat v-else color="transparent">
      <v-card-title>
        <v-btn
          icon
          @click="coreCardTypeId = null"
          color="secondary"
          class="mr-2"
        >
          <v-icon>west</v-icon>
        </v-btn>
        {{ coreCard.name }}
        <v-spacer></v-spacer>
        <a class="subtitle-2 info--text" @click="dismissAll">
          Dismiss all
        </a>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-chip
              v-for="(category, i) in categories"
              :key="i"
              :outlined="categoryId != category.id"
              color="secondary"
              class="mr-1"
              small
              @click="
                categoryId = categoryId == category.id ? null : category.id
              "
            >
              <span v-html="category.icon" class="mr-2"></span>
              {{ category.count }} {{ category.name }}
            </v-chip>
          </v-col>
          <loading-spinner v-if="saving"></loading-spinner>
          <template v-else>
            <v-col cols="12" v-for="(insight, i) in selected_insights" :key="i">
              <insight-card :insight="insight"></insight-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import InsightCoreCard from "@/components/insights/InsightCoreCard";
import InsightCard from "@/components/insights/InsightCard";
export default {
  name: "InsightsNavigationDrawer",
  components: { InsightCoreCard, InsightCard },
  data: () => ({
    clipped: true,
    miniVariant: false,
    saving: false,
    loading: false,
    coreCardTypeId: null,
    categoryId: null
  }),
  watch: {
    insights_drawer(val, oldVal) {
      if (val && val != oldVal) {
        if (!this.insights.length) {
          this.loading = true;
          this.$store
            .dispatch("insights/getInsights")
            .catch(error => {
              this.logError(error);
              this.$root.$alert(
                "Error Occurred",
                "An error occurred while loading insights."
              );
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }
  },
  computed: {
    drawer: {
      get() {
        return this.insights_drawer;
      },
      set(val) {
        this.$store.dispatch("insights/setDrawer", val);
      }
    },
    coreCard() {
      if (!this.coreCardTypeId) {
        return null;
      }
      return this.settings.coreCardTypes.find(x => x.id == this.coreCardTypeId);
    },
    coreCards() {
      let ids = this._.uniq(this.insights.map(x => x.type.coreCardTypeId));
      return (this.settings.coreCardTypes || []).filter(x =>
        ids.includes(x.id)
      );
    },
    categories() {
      return this.insight_categories.map(x =>
        Object.assign(x, {
          count: this.insights.filter(
            y =>
              y.type.coreCardTypeId == this.coreCardTypeId &&
              y.type.categoryId == x.id
          ).length
        })
      );
    },
    selected_insights() {
      return this._.orderBy(
        this.insights
          .filter(
            y =>
              y.type.coreCardTypeId == this.coreCardTypeId &&
              (y.type.categoryId == this.categoryId || this.categoryId == null)
          )
          .map(x => Object.assign(x, { abs_value: Math.abs(x.value) })),
        ["createdDate", "type.sort", "abs_value"],
        ["desc", "asc", "desc"]
      );
    },
    lastUpdatedDays() {
      let val = this._.min(this.insights.map(x => x.createdDays));
      if (val == 0) {
        return "today";
      } else if (val == 1) {
        return "yesterday";
      }
      return `${val} days ago`;
    },
    ...mapGetters({
      settings: "profile/settings",
      insights: "insights/list",
      insights_drawer: "insights/drawer",
      insight_categories: "lookup/insight_categories"
    })
  },
  methods: {
    cancel() {
      this.$store.dispatch("insights/setDrawer", false);
    },
    setCoreCard(obj) {
      this.coreCardTypeId = obj.id;
      this.categoryId = obj.categoryId;
    },
    dismissAll() {
      this.saving = true;
      let callArray = this.selected_insights.map(x =>
        this.$store.dispatch("insights/deleteInsight", x.id)
      );
      Promise.all(callArray).then(() => {
        this.saving = false;
        this.coreCardTypeId = null;
      });
    }
  }
};
</script>
